import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, Upload, Icon, Tooltip, message, Spin } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/dobAttachmentActions'
import { filterCaseInsensitive } from '../../../util'
import _ from 'lodash'
import styled from 'styled-components'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

class DobAttachments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      content: null,
      fileList: []
    }
  }

  componentWillMount() {
    this.props.fetchDobFolders({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.props.getDobAttachments({
      dobAttachmentFolderId: row.id
    })
    this.setState({
      modalVisible: true,
      currentId: row.id,
      content: row
    })
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      currentId: 0,
      content: null,
      fileList: []
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.state.currentId === 0) {
        this.props.createDobFolder({
          jobId: this.props.jobId,
          name: values.name
        })
        message.warning('Uploading file...')
      } else {
        this.props.updateDobfolder({
          jobId: this.props.jobId,
          name: values.name,
          dobAttachmentFolderId: this.state.currentId
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      this.setState({ content: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteDobFolder({
      dobAttachmentFolderId: this.state.currentId,
      jobId: this.props.jobId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      content: null,
      currentId: 0,
      modalVisible: false
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'dob_attachment')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('dobAttachmentFolderId', this.state.currentId)
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)

    this.props.uploadDobAttachment({
      formData: formData,
      dobAttachmentFolderId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description,
      attachmentStatus: row.status
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateDobAttachmentDescription({
      attachmentId: this.state.attachmentId,
      dobAttachmentFolderId: this.state.currentId,
      description: this.state.attachmentDescription,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteDobAttachment({
      attachmentId: this.state.attachmentId,
      dobAttachmentFolderId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  render() {
    const { content } = this.state

    const dobFolders = _.get(this.props, 'dobAttachmentActions.dobFolders.data')
    const dobAttachments = _.get(this.props, 'dobAttachmentActions.jobDobAttachments.data')
    const uploadingAttachment = _.get(this.props, 'dobAttachmentActions.uploadingAttachment')
    const deletingAttachment = _.get(this.props, 'dobAttachmentActions.deletingAttachment')
    const loadingAttachments = _.get(this.props, 'dobAttachmentActions.loadingAttachments')

    const { getFieldDecorator } = this.props.form

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    if (!dobFolders) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="DOB Attachments"
          okText={content ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width="90%"
          maskClosable={false}
        >
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Folder Name">
                  {getFieldDecorator('name', {
                    validateTrigger: 'onSelect',
                    rules: [
                      {
                        required: true,
                        message: 'You must type a name'
                      }
                    ],
                    initialValue: content ? content.folder_name : ''
                  })(<Input />)}
                </FormItem>
              </div>
            </div>
            {content && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h6>
                      <Icon type="file" /> DOB Files
                    </h6>
                  </div>
                  <div className="col-md-6 text-right">
                    {uploadingAttachment && (
                      <div className="text-success">
                        <Icon type="loading" /> Uploading File(s)
                      </div>
                    )}
                    {deletingAttachment && (
                      <div className="text-danger">
                        <Icon type="loading" /> Deleting File(s)
                      </div>
                    )}
                  </div>
                </div>
                {dobAttachments &&
                  dobAttachments.length > 0 && (
                    <Spin spinning={loadingAttachments}>
                      <ReactTable
                        defaultPageSize={5}
                        data={dobAttachments}
                        getTrProps={(state, rowInfo, column, instance) => ({
                          onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                        })}
                        columns={[
                          {
                            Header: 'Attached Files',
                            columns: [
                              {
                                Header: 'Filename',
                                id: 'filename',
                                accessor: 'filename',
                                Cell: d => (
                                  <Tooltip title={d.original.filename}>
                                    {d.original.filename}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Status',
                                accessor: 'status'
                              },
                              {
                                Header: 'Description',
                                id: 'description',
                                accessor: 'description',
                                Cell: d => (
                                  <Tooltip title={d.original.description}>
                                    {d.original.description}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Created By',
                                id: 'created_by',
                                accessor: d =>
                                  `${d.created_by_first_name}  ${d.created_by_last_name}`,
                                Cell: d => {
                                  const r = `${d.original.created_by_first_name}  ${
                                    d.original.created_by_last_name
                                  }`
                                  return <Tooltip title={r}>{r}</Tooltip>
                                }
                              },
                              {
                                Header: 'Updated By',
                                id: 'updated_by',
                                accessor: d =>
                                  `${d.updated_by_first_name}  ${d.updated_by_last_name}`,
                                Cell: d => {
                                  const r = `${d.original.updated_by_first_name}  ${
                                    d.original.updated_by_last_name
                                  }`
                                  return <Tooltip title={r}>{r}</Tooltip>
                                }
                              },
                              {
                                Cell: row => (
                                  <Tooltip placement="left" title="Open this file on a new window">
                                    <a target="_blank" href={row.original.signedUrl}>
                                      <Icon type="export" className="fontSize20" />
                                    </a>
                                  </Tooltip>
                                ),
                                maxWidth: 35
                              }
                            ]
                          }
                        ]}
                        defaultSorted={[
                          {
                            id: 'id',
                            desc: true
                          }
                        ]}
                        className="-striped -highlight"
                      />
                    </Spin>
                  )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> Save
                      </Button>{' '}
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2" />
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload DOB File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {content && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          DOB Attachments
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD DOB FOLDER
            </div>
          </div>
        </div>
        {dobFolders && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== undefined) {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={dobFolders}
            columns={[
              {
                columns: [
                  {
                    Header: 'Name',
                    id: 'folder_name',
                    accessor: 'folder_name',
                    Cell: d => (
                      <Tooltip title={d.original.folder_name}>{d.original.folder_name}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name}  ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name}  ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name}  ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name}  ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ dobAttachmentActions }, ownProps) => ({ dobAttachmentActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

DobAttachments.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(DobAttachments))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/DobAttachments.js